export const CALENDAR_DAY_TARGET_DATE = "calendar-day-target-date"
export const NUM_OF_ROWS = 6
export const NUM_OF_COLS = 7
